import { Outlet, useNavigate } from "react-router-dom";
import { FaChartBar, FaDoorOpen, FaRegClock, FaUserAlt } from "react-icons/fa";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { usePageDateTime } from "../hooks/usePageDateTime";

function RootLayout() {
  const navigate = useNavigate();
  const { logout, role, user } = useAuth();

  const dateTime = usePageDateTime();
  const displayName = user?.username || user?.email || "User";
  const displayRole = role || "User";

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <main className="app-scrollbar h-screen overflow-y-auto bg-[#f4f7fb] pt-[74px] max-[1180px]:pt-[130px] max-[720px]:pt-[200px]">
      <header className="fixed inset-x-0 top-0 z-50 grid min-h-[74px] grid-cols-[178px_minmax(240px,1fr)_282px] items-center gap-3 bg-[#073d70] px-5 text-white shadow-sm max-[1180px]:grid-cols-[158px_1fr] max-[1180px]:gap-y-3 max-[720px]:grid-cols-1 max-[720px]:justify-items-center max-[720px]:px-3 max-[720px]:py-3">
        <Logo compact />

        <div className="flex items-center justify-center gap-3 max-[1180px]:justify-end max-[720px]:justify-center">
          <span
            className="inline-flex h-[22px] w-[22px] flex-none items-center justify-center rounded-[4px] border border-white/60 bg-gradient-to-br from-[#c9ddff] to-[#f7fafc] text-[#0d73ff] shadow-inner"
            aria-hidden="true"
          >
            <FaChartBar className="h-3.5 w-3.5" />
          </span>
          <h1 className="m-0 text-[1.35rem] font-extrabold max-[720px]:text-center max-[720px]:text-[1.05rem] xl:text-[1.45rem]">
            Pargro Intranet Dashboard
          </h1>
        </div>

        <div className="justify-self-end text-right text-sm font-bold max-[1180px]:col-span-full max-[1180px]:flex max-[1180px]:w-full max-[1180px]:items-center max-[1180px]:justify-between max-[720px]:col-auto max-[720px]:flex-col max-[720px]:gap-2 max-[720px]:text-center">
          <div className="flex items-center justify-end gap-2.5 whitespace-nowrap max-[720px]:flex-wrap max-[720px]:justify-center max-[720px]:text-xs">
            <FaUserAlt className="h-3 w-3 flex-none text-[#432071]" aria-hidden="true" />
            <span>
              {displayName} ({displayRole})
            </span>
            <span className="inline-flex items-center gap-1.5">
              <FaRegClock className="h-3 w-3 flex-none text-[#64748b]" aria-hidden="true" />
              {dateTime}
            </span>
          </div>
          <button
            className="mt-2 inline-flex items-center gap-2 border-0 bg-transparent p-0 text-[0.95rem] font-extrabold text-white hover:underline hover:underline-offset-[5px] focus-visible:underline focus-visible:underline-offset-[5px] max-[1180px]:mt-0"
            type="button"
            onClick={handleLogout}
          >
            <FaDoorOpen className="h-3.5 w-3.5 flex-none text-[#c98655]" aria-hidden="true" />
            Logout
          </button>
        </div>
      </header>

      <Outlet />
    </main>
  );
}

export default RootLayout;
